import { ApiService } from './api.service';
import { endpoints } from './endpoints';

import { FeatureFlag, ActiveFlagsMap, CreateFeatureFlagPayload, UpdateFeatureFlagPayload } from '@/types/entities/feature-flag';

export class FeatureFlagsApiService extends ApiService {
  getAll = async (): Promise<FeatureFlag[]> => this.get(endpoints.featureFlags.all);

  getActive = async (): Promise<ActiveFlagsMap> => this.get(endpoints.featureFlags.active);

  getById = async (id: string): Promise<FeatureFlag> => this.get(endpoints.featureFlags.byId(id));

  create = async (data: CreateFeatureFlagPayload): Promise<FeatureFlag> =>
    this.post(endpoints.featureFlags.all, data);

  update = async (id: string, data: UpdateFeatureFlagPayload): Promise<FeatureFlag> =>
    this.patch(endpoints.featureFlags.byId(id), data);

  toggle = async (id: string): Promise<FeatureFlag> =>
    this.patch(endpoints.featureFlags.toggle(id), {});

  remove = async (id: string): Promise<void> => this.delete(endpoints.featureFlags.byId(id));
}

export const featureFlagsApiService = new FeatureFlagsApiService();

export const {
  getAll: getFeatureFlags,
  getActive: getActiveFeatureFlags,
  getById: getFeatureFlagById,
  create: createFeatureFlag,
  update: updateFeatureFlag,
  toggle: toggleFeatureFlag,
  remove: removeFeatureFlag,
} = featureFlagsApiService;
